import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { DepartmentCreateInput } from '@libs/types/src/mado/input-type/organization/department.create-input';
import { DepartmentUpdateInput } from '@libs/types/src/mado/input-type/organization/department.update-input';
import { DepartmentGridObject, DepartmentObject } from '@libs/types/src/mado/object-type/organization/department.object';

@Injectable({ providedIn: 'root' })
export class DepartmentGqlService extends GqlServiceV2 {

    public getDepartments(input: GridInput | null, frag: string) {
        return this.query<DepartmentGridObject>(
            `
                query($input: GridInput!) {
                    department {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createDepartment(input: DepartmentCreateInput, frag: string) {
        return this.mutate<DepartmentObject>(
            `
                mutation($input: DepartmentCreateInput!) {
                    department {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateDepartment(input: DepartmentUpdateInput, frag: string) {
        return this.mutate<DepartmentObject>(
            `
                mutation($input: DepartmentUpdateInput!) {
                    department {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
